<template>
  <b-modal
    :id="idModal"
    :ref="idModal"
    size="xl"
    body-classes="p-0"
    @hidden="reseteaValores"
    @show="cargaInicial"
  >
    <div class="text-center text-muted mb-4">
      <small>Escriba el nombre del Curso</small>
    </div>
    <b-form role="form">
      <base-input
        alternative
        v-model="nombrenuevoCurso"
        class="mb-3"
        placeholder="Nombre"
      >
      </base-input>
    </b-form>
    <b-form>
      <tabla-catequistas-simple :data="catequistas" :multiple="false" />
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="creaNuevoCurso()"
          :disabled="activaBoton"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import tablaCatequistasSimple from "@/components/Tables/TablaCatequistasSimple.vue";

//Spinner
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: { tablaCatequistasSimple },
  props: {
    idModal: {
      type: String
    },
    cursoSelect: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      nombrenuevoCurso: "",
    };
  },
  computed: {
    activaBoton() {
      if (this.nombrenuevoCurso != "") {
        return false;
      } else {
        return true;
      }
    },
    catequistas() {
      if (this.$store.getters.getTodosCatequistasSimple != undefined) {
        loader.close();
        return this.$store.getters.getTodosCatequistasSimple.map((element) => {
          return {
            check:
              this.cursoSelect != null &&
              this.cursoSelect.responsables.find(
                (element2) => element.id == element2.id && element2
              )
                ? true
                : false,
            id: element.id,
            catequista:
              element.nombre +
              " " +
              element.apellido1 +
              " " +
              element.apellido2,
          };
        });
      } else {
        loader.open();
        this.$store.dispatch("cargaCatequistasSimple");
        return [];
      }
    },
  },
  methods: {
    cargaInicial() {
      this.reseteaValores();
      if (this.cursoSelect != null) {
        this.nombrenuevoCurso = this.cursoSelect.nombre;
      }
    },
    reseteaValores() {
      this.nombrenuevoCurso = "";
    },
    creaNuevoCurso() {
      this.$emit("creaNuevoCurso", this.nombrenuevoCurso, this.catequistas);
    },
  },
};
</script>
<style></style>
